
import { defineComponent, PropType } from 'vue'

import { LocalStoreDomainVerification, SSO_SETUP_STATES } from '~/types/cloudSso'
import { IdentityProvider, Maybe, VerifiableDomain } from '~/types/types'

export default defineComponent({
  name: 'SsoConfiguration',
  props: {
    verifiableDomain: {
      type: Object as PropType<Maybe<VerifiableDomain>>,
      required: true
    },
    identityProvider: {
      type: Object as PropType<Maybe<IdentityProvider>>,
      required: true
    },
    domainName: {
      type: String,
      required: true
    },
    verifyingDomain: {
      type: Boolean,
      default: false
    },
    isInProgress: {
      type: Object as PropType<LocalStoreDomainVerification>,
      required: true
    },
    canSetupSso: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      SSO_SETUP_STATES
    }
  },
  model: {
    prop: 'domainName',
    event: 'input'
  },
  computed: {
    SSO_DOCS_LINK(): string {
      return 'https://docs.deepsource.com/docs/integrations-sso'
    },
    ssoStatus(): SSO_SETUP_STATES | '' {
      if (this.isInProgress?.state === SSO_SETUP_STATES.VERIFICATION_IN_PROGRESS) {
        return SSO_SETUP_STATES.VERIFICATION_IN_PROGRESS
      }

      if (!this.canSetupSso) {
        return SSO_SETUP_STATES.NEED_TO_UPGRADE
      }

      if (this.verifiableDomain === null) {
        return SSO_SETUP_STATES.NEEDS_INFORMATION
      }

      if (this.verifiableDomain?.verified) {
        return SSO_SETUP_STATES.VERIFICATION_COMPLETE
      }

      return ''
    },
    isSSONotConfigurable(): boolean {
      return this.ssoStatus === SSO_SETUP_STATES.NEED_TO_UPGRADE
    },
    isSSOVerificationPending(): boolean {
      return this.ssoStatus === SSO_SETUP_STATES.VERIFICATION_IN_PROGRESS
    },
    isSAMLConfigurable(): boolean {
      return this.ssoStatus === SSO_SETUP_STATES.VERIFICATION_COMPLETE
    },
    isSAMLConfigured(): boolean {
      return this.isSAMLConfigurable && this.identityProvider !== null
    },
    domainInVerification() {
      return this.isSSOVerificationPending && this.isInProgress?.domainName
        ? this.isInProgress.domainName
        : 'Domain'
    },
    domainInput: {
      get() {
        return this.domainName
      },
      set(value: string) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    verifyDomain() {
      this.domainInput
        ? this.$emit('verify-domain')
        : this.$toast.danger('Please enter a valid domain')
    }
  }
})
